<template>
  <div>
  <div class="overlay-loader" v-if="overlay" ></div>
  <div v-if="loader" id="loader" :style="loaderStyle"></div>
  </div>
  </template>
  
  <script>
  export default {
    name: "SLoader",
    components: {
   
  },
    data() {
      return {
    
      };
    },
    props: {
  size: { type: Number, default: 50 },
  thickness: { type: Number, default: 4 },
  display:{Type: String, default: "fixed"},
      background: { type: String, default: "#f3f3f3" },
      color: {Type: String, default: "red"},
      overlay: { default: true },
      loader: { default: true },
      left:{ type: Number, default: 50}
      
  },
    methods: {
     
    },
    mounted() {},
    computed: {
      
      loaderStyle(){
          let height, width, thick, clr, bgclr, lft, dsply;
  
          height = '16px';
          width = "16px";
          thick = "4px"
          clr = "red";
          lft=50;
          bgclr = "#f3f3f3"
          
          if(this.size){
            height = this.size + "px";
            width = this.size + "px";
          }
          if(this.left){
            lft = this.left + "%";
           
          }
          if(this.thickness)
          {
            thick = this.thickness + "px";
            
          }
          if(this.display)
          {
            dsply = this.display;
          }
          if(this.color)
          {
            clr = this.color;
          }
          if(this.background)
          {
            bgclr = this.background;
          }
          return{
            "height":height + "!important",
            "width":width + "!important",
            "left":lft + "!important",
            // "position": dsply +"!important",
            "border-top": thick +" solid "+ clr +" !important",
            "border-left": thick +" solid "+ bgclr +" !important",
            "border-bottom": thick +" solid "+ bgclr +" !important",
            "border-right": thick +" solid "+ bgclr +" !important", 
          };
  
        },
    }
  };
  </script>
  <style scoped>
   
  #loader {
    position: relative;
    top:50%;
    left:50%;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid red;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
    z-index: 99999;
  }
  .overlay-loader {
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    pointer-events: all;
    background-color: rgba(0, 0, 0, 0.15);
  }
  
  /* Safari */
  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  </style>
  